import React from 'react';

import KPISkeletonLoader from 'components/utility/ContentLoader/KPILoader/KPILoader';

import { KPIListWrapper, KPIList } from 'components/Overview/KPIs/shared.style';
import metrics from 'maps/metrics';
import KPI from 'components/data-containers/Overview/shared/KPI';

interface IKPIsDataProps {
  rtdValue: number;
  value: number;
  change: number;
  title: string;
  isPending: boolean;
}

/**
 * This component renders KPI's for the blocks on Overview pages.
 *
 * @param props
 * @param {number} props.rtdValue
 * @param {number} props.value
 * @param {number} props.change
 * @param {string} props.title
 * @param {bool} props.isPending
 *
 */
const KPIsData: React.FC<IKPIsDataProps> = (props) => {
  const { rtdValue, title, isPending, value, change } = props;

  if (isPending) {
    return <KPISkeletonLoader />;
  }

  return (
    <KPIListWrapper>
      <KPIList>
        <KPI value={value} change={change} title={title} />
        <KPI value={rtdValue} title={metrics.count_rtd.label} />
      </KPIList>
    </KPIListWrapper>
  );
};

export default KPIsData;
